import { lazy } from 'react';
import { useMsal } from '@azure/msal-react';
import { LocalStorageKey } from '@constants/storage-keys.constants';
import { Button } from '@components/Button';

const UnauthorisedSvg = lazy(() => import('@assets/images/unauthorised.svg'));

export default function UnauthorisedLogin() {
	const { instance } = useMsal();
	const { MP_URL } = JSON.parse(localStorage.getItem(LocalStorageKey.CONFIG_KEY) || '{}');

	const redirectToLogin = () => {
		instance.disableAccountStorageEvents();
		void instance.logoutRedirect({
			account: instance.getActiveAccount(),
			onRedirectNavigate: () => {},
		});
	};

	return (
		<div className='flex flex-col items-center tablet:justify-center text-center min-h-screen px-6 py-10 text-xl'>
			<div className='flex flex-col items-center justify-center gap-6 h-full grow tablet:grow-0'>
				<div className='flex w-[192px] tablet:w-[380.5px] desktop:w-[318px] tablet:mb-[17px] desktop:mb-[38px] justify-center h-auto'>
					<UnauthorisedSvg />
				</div>
				<h2 className='font-semibold text-xl'>Unauthorised Login</h2>
				<div>
					<p className='text-xl max-w-[584px] mb-6 tablet:mb-0'>Access is only available to outlet and POS accounts. </p>
					<p className='desktop:hidden'>
						Partner HQ Staff? Login at the <span className='font-semibold'>Merchant Admin Portal</span> via desktop.
					</p>
					<p className='hidden desktop:block mb-6'>
						Partner HQ Staff? Login at the{' '}
						<a href={MP_URL} className='text-cyan font-semibold' target='_blank'>
							Merchant Admin Portal.
						</a>
					</p>
				</div>
			</div>
			<div className='w-full px-6'>
				<Button className='w-full tablet:w-[327px] mt-10' onClick={redirectToLogin}>
					Go back
				</Button>
			</div>
		</div>
	);
}
